<template>
    <DashboadCard :borderColor="borderColor" class="counter-card">
        <div class=" counter-card__icon">
            <DashboardIcon :icon="icon" :color="color" />
        </div>
        <div class="counter-card__content">
            <div class="counter-card__top">
                <div class="counter-card__value">{{ formattedValue }}</div>
                <div v-if="percentage" class="counter-card__percentage">({{ percentage }}%)</div>
            </div>
            <div class="counter-card__title">{{ title }}</div>

        </div>
    </DashboadCard>
</template>

<script>
import DashboardIcon from './DashboardIcon.vue';
import DashboadCard from './DashboadCard.vue';
import { thousandSeparator, applyTransparency } from '@/utils/helpers';
export default {
    name: 'CounterCard',
    components: {
        DashboardIcon,
        DashboadCard
    },
    props: {
        icon: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        value: {
            type: Number,
            required: true
        },
        percentage: {
            type: Number,
            required: false
        },
        color: {
            type: String,
            required: true
        }
    },
    computed: {
        formattedValue() {
            return thousandSeparator(this.value)
        },
        borderColor() {
            return applyTransparency(this.color, 0.3)
        }
    }
}
</script>

<style scoped>
.counter-card {
    display: flex;
    gap: 1rem;
    align-items: center;
    padding: 1rem;
}

.counter-card__percentage {
    font-size: 0.875rem;
    color: var(--foreground);
    opacity: 0.7;
}

.counter-card__top {
    display: flex;
    align-items: flex-end;
    gap: 4px;
}


.counter-card__icon i {
    font-size: 2rem;
    color: var(--primary-color);
}

.counter-card__content {
    flex: 1;
}

.counter-card__title {
    font-size: 0.875rem;
    color: var(--foreground);
    opacity: 0.7;
}

.counter-card__value {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: -5px;
}
</style>
